import { Component, OnInit, Input, Inject } from '@angular/core';
import { FichaMedicaAvances } from '../../../../models/fichaMedicaAvances';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErroresService } from '../../../../core/services/errores.service';
import { FichaMedicaAvancesService } from '../../../../services/ficha-medica-avances.service';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { FichaMedicaAvancesEditarDialogComponent } from '../ficha-medica-avances-editar-dialog/ficha-medica-avances-editar-dialog.component';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-ficha-medica-avances-list',
  templateUrl: './ficha-medica-avances-list.component.html',
  styleUrls: ['./ficha-medica-avances-list.component.css']
})
export class FichaMedicaAvancesListComponent implements OnInit {

  @Input() fichaId;
  
  tituloTabla: string = "FichaMedicaAvances";
  variableDialog: boolean;

  avances: any;
  avance: FichaMedicaAvances;
  eliminando: boolean;
  eliminacionInvalida: boolean;
  buscando: boolean;
  MensajeError: string;
  mensajeExitoGuardado: string;

  rows: any;
  nominaInvalida: boolean;
  rowsExport: any;
  columns: any;
  guardando: boolean;
  permisoEdicion: boolean = false;
  
  constructor(private avancesService: FichaMedicaAvancesService, 
              private dialog: MatDialog, 
              private snackBar: MatSnackBar, 
              private erroresService: ErroresService,
              private momentService: MomentSetService,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void
  {
    if (this.data.param.id != 0)
    {
      this.fichaId = this.data.param.id;
      this.buscarAvances();
    }

    this.permisoEdicion = this.data.permisoEdicion;
  }

  buscarAvances()
  {
    this.buscando = true;
    this.avancesService.GetByFicha(this.fichaId).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        this.avances = data;
        this.rows = data;
        this.buscando = false;
        this.rowsExport = data.map(function(obj) {
          return {
            fichaMedica: obj.fichaMedica,
            fecha: obj.fecha,
            avance: obj.avance
          }
        });
      },
      error =>
      {
        this.erroresService.MostrarErrorByStatus(error, "Error al consultar");
        this.buscando = false;
      }
    );
  }

  add(e)
  {
    let fecha: FichaMedicaAvances = {
      id: 0,
      fichaMedica: this.fichaId
    };

    this.abrirDialogo(fecha, 0, 0);
  }

  abrirDialogo(avance: FichaMedicaAvances, index: number, detIndex: number)
  {
    let dialogRef = this.dialog.open(FichaMedicaAvancesEditarDialogComponent, {
      width: '700px',
      data: { param: avance, permisoEdicion: this.permisoEdicion },
      panelClass: 'overflow',
      disableClose: true,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result != '')
      {
        result.fecha = this.momentService.convertDateServer(result.fecha);

        if (avance.id == 0)
        {
          this.mensajeExitoGuardado = "Datos guardados";
        }
        else
        {
          this.mensajeExitoGuardado = "Datos actualizados";
        }

        this.snackBar.open(this.mensajeExitoGuardado, "OK", { duration: 10000 });
        this.buscarAvances();
      }
    });
  }

  cancelar(): void
  {
    this.dialog.closeAll();
  }

  edit(row, rowIndex, detIndex)
  {
    this.abrirDialogo(row, rowIndex, detIndex);
  }

  delete(row, rowIndex)
  {

    let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result)
      {
        this.eliminando = true;

        let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
          width: '400px'
        });
        dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

        this.eliminando = true;
        this.avancesService.delete(row.id).subscribe(
          response =>
          {
            let index = this.avances.findIndex(x => x.id == row.id);
            if (index != -1)
            {
              this.avances.splice(index, 1);
              this.avances = [...this.avances];
            }

            this.snackBar.open("El registro se eliminó correctamente.", "OK", { duration: 10000 });    

            this.eliminando = false;

            setTimeout(function ()
            {
              dialogProcesandoRef.close();
            });
          },
          error =>
          {
            if (error.status == 400)
            {
              this.eliminacionInvalida = true;
            }
            else
            {
              this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
            }
            this.eliminando = false;
            dialogProcesandoRef.close();
          });
      }
    });
  }
}

